import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  useTheme,
  GridItem,
  Circle,
  Text,
  Center,
  Flex,
  Box,
} from '@chakra-ui/react';

import { DeptGrid } from '@rsc/ui-components/dept/design-system';
import Image from '@rsc/ui-components/tailwind/Image';
import RichText from '@rsc/ui-components/dept/molecules/RichText';
import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

export default function TextHeroesBlog({ block }) {
  const theme = useTheme();
  const { tt } = useUiComponentsInternationalContext();

  const handleAlignment = (
    leftValue,
    centerValue,
    rightValue,
    defaultAlignment
  ) => {
    const values = {
      left: leftValue,
      center: centerValue,
      right: rightValue,
    };

    return {
      base: defaultAlignment ?? leftValue,
      lg: values[block.alignment] || defaultAlignment,
    };
  };

  return (
    <Container {...generateSectionId(block)} pt={{ base: 6, lg: 8 }}>
      <DeptGrid>
        <GridItem colSpan={{ base: 6, lg: 8 }}>
          <Flex
            gap={6}
            flexDir={handleAlignment('row', 'column', 'row-reverse', 'column')}
            alignItems={handleAlignment('flex-start', 'center', 'flex-start')}
          >
            <Circle as={Center} bg="brand.sunny" h={16} w={16}>
              {block?.icon?.asset?.url ? (
                <Image sanityImage={block?.icon} srcSetBasisWidth={48} />
              ) : (
                <Image
                  alt={tt(s => s.blocksDeptComponents.expertBadgeAlt)}
                  src={theme.images.inkExpertBadge}
                  width="48px"
                />
              )}
            </Circle>
            <Box>
              <Text as="h1" textStyle="h2" fontWeight="black" mb={4}>
                {block.headline}
              </Text>
              <RichText body={block.copyBlock} />
            </Box>
          </Flex>
        </GridItem>
      </DeptGrid>
    </Container>
  );
}

TextHeroesBlog.propTypes = {
  block: PropTypes.shape({
    icon: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    headline: PropTypes.string,
    copyBlock: PropTypes.arrayOf(
      PropTypes.shape({
        _type: PropTypes.string.isRequired,
        rows: PropTypes.arrayOf(
          PropTypes.shape({
            cells: PropTypes.arrayOf(PropTypes.string.isRequired),
          })
        ),
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    alignment: PropTypes.string,
  }).isRequired,
};
